import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { graphql } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/withStyles';
import Loader from '../../../components/Common/Loader/Loader';
import AddSubCategoryForm from '../../../components/SiteAdmin/AddSubCategoryForm/AddSubCategoryForm';
import getActiveCategories from './getActiveCategories.graphql';
import s from './AddSubCategory.css';

export class AddSubCategory extends Component {

	render() {
		const { categories, categories: { loading } } = this.props;
		return (
			<Loader type={"page"} show={loading}>
				<div className={s.root}>
					<div className={s.container}>
						<div className={s.paddingRoutesSection}>
							{!loading && <AddSubCategoryForm categories={categories} />}
						</div>
					</div>
				</div>
			</Loader >
		)
	}
}

export default compose(withStyles(s),
	graphql(getActiveCategories, {
		name: 'categories',
		options: {
			ssr: true,
			fetchPolicy: 'network-only'
		}
	})
)(AddSubCategory);

